export interface TaskDTO {
  id: number;
  status: TaskDTOStatus;
  type: TaskDTOType;
  creationTimestamp: string;
  fileName: string;
  result: string;
}

type TaskDTOStatus =
  | 'PROCESSING'
  | 'COMPLETED'
  | 'COMPLETED WITH WARNINGS'
  | 'FAILED';
type TaskDTOType = 'GIFT CARDS IMPORT' | 'CUSTOMERS IMPORT';

export interface Task {
  id: number;
  name: string;
  status: TaskStatus;
  type: TaskType;
  feedback?: boolean;
  startDate: string;
}

export type TaskStatus = 'pending' | 'success' | 'warning' | 'failed';
export type TaskType = 'import' | 'export';

const taskStatusMapping: { [key in TaskDTOStatus]: TaskStatus } = {
  PROCESSING: 'pending',
  COMPLETED: 'success',
  'COMPLETED WITH WARNINGS': 'warning',
  FAILED: 'failed'
};

const taskTypeMapping: { [key in TaskDTOType]: TaskType } = {
  'GIFT CARDS IMPORT': 'import',
  'CUSTOMERS IMPORT': 'import'
};

export const convertTaskDTO = (dto: TaskDTO): Task => ({
  id: dto.id,
  name: `${dto.type.toLowerCase()} - ${dto.fileName}`,
  status: taskStatusMapping[dto.status] || 'pending',
  type: taskTypeMapping[dto.type],
  feedback: dto.status === 'COMPLETED WITH WARNINGS' || dto.status === 'FAILED',
  startDate: dto.creationTimestamp
});
